export class ExportFilter {

  area = '';
  chapter = '';
  enddate = null;
  fileFormat = 'xlsx';
  form = 0;
  ids: number[] = [];
  place = '';
  region = '';
  startdate = null;
  status = '';
  supportMeasure = '';
  type = 'course';
  fields: string[] = [];
  district = '';
  gau = '';
}
